/**
 * Contract status (`lib_situation` of `WS2_EA_TAB_POLICES` — fiche 22087):
 * the value only drives the dot colour — green « EN COURS », red
 * « RESILIE ». Declarative badge + tooltip maps (never inline JSX
 * conditions).
 */

import { normaliseStatus, type StatusBadgeConfig } from '../shared/statusBadgeConfig';

/** `lib_situation` → dotted badge (green « En cours », red « Résilié »). */
export const CONTRACT_STATUS_BADGE: StatusBadgeConfig = {
  entries: {
    'EN COURS': { label: 'En cours', variant: 'success' },
    RESILIE: { label: 'Résilié', variant: 'error' },
  },
  fallbackVariant: 'default',
  dot: true,
};

/** Tooltip of the status dot, keyed like {@link CONTRACT_STATUS_BADGE}. */
export const CONTRACT_STATUS_TOOLTIPS: Readonly<Record<string, string>> = {
  'EN COURS': 'Contrat en cours',
  RESILIE: 'Contrat résilié',
};

/** Tooltip of a raw status value, or `undefined` when none is configured. */
export function contractStatusTooltip(value: unknown): string | undefined {
  if (typeof value !== 'string' || value.trim() === '') return undefined;
  const normalised = normaliseStatus(value);
  const key = Object.keys(CONTRACT_STATUS_TOOLTIPS).find(
    (candidate) => normaliseStatus(candidate) === normalised,
  );
  return key === undefined ? undefined : CONTRACT_STATUS_TOOLTIPS[key];
}
